import React from "react"
import { Box } from "@mui/material"
import Loader from "../GlobalComponents/Loader"
import Search from "../GlobalComponents/Search"
import { PlusButton } from "../GlobalComponents/CommonComponents"
import { invoiceInfoSearch, invoiceTableKeys, patientInfoSearch } from "../../utils/constants"
import InvoiceSave from "./invoiceSave"
import { useInvociesContainer } from "./Conatiner"
import { CommonTable, InVoiceTableRow } from "../GlobalComponents/Table"
import { FileModal } from "../Register/FileUpload"
import { PreviewModal } from "./PreviewModal"

const Invoice = (props) => {
  const {
    handleSearchChange,
    setShowInvoicesList,
    showInvoicesList,
    isLoading,
    invocieList,
    modalData,
    setModalData,
    paginationData,
    setPaginationData,
    observerRef,
    tableContainerRef,
    loadingStatus,
  } = useInvociesContainer(props)

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "99%",
        padding: "20px 40px",
        overflow: "hidden",
      }}
    >
      {isLoading && <Loader />}

      {showInvoicesList ? (
        <Box
          sx={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              marginBottom: "20px",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              width: "100%",
            }}
          >
            {/* <Box style={{ marginRight: "10px", marginLeft: "auto" }}> */}
            <div className="search-container">
              <Search
                addStyle={{ width: "100%" }}
                placeholder={invoiceInfoSearch}
                searchValue={paginationData.searchValue}
                handleSearchChange={handleSearchChange}
                onClose={() =>
                  setPaginationData((prev) => ({ ...prev, searchValue: "", endReached: false, count: 0 }))
                }
              />
            </div>
            <Box style={{ marginLeft: "auto" }}>
              <PlusButton onClickPlus={() => setShowInvoicesList(false)} />
            </Box>
          </Box>

          <div className="table-container-div" ref={tableContainerRef}
            style={{
              display: "flex", 
              justifyContent: "center",
              width: "100%",
              // height: "500px"
            }}>
            <CommonTable
              headerKeys={invoiceTableKeys}
              rowData={invocieList}
              onPressRow={(data) => setModalData({ ...data, open: true })}
              rowComponent={(data) => (
                <InVoiceTableRow
                  rowData={data}
                  onViewPress={(data) => setModalData({ ...data, open: true })}
                />
              )}
              observerRef={observerRef}
              loadingStatus={loadingStatus}
              searchValue={paginationData?.searchValue}

            />
          </div>
        </Box>
      ) : (
        <div style={{ overflow: "scroll" }}>
          <InvoiceSave setShowInvoicesList={setShowInvoicesList} />
        </div>
      )}

      <PreviewModal
        showModal={modalData.open}
        setShowModal={setModalData}
        invoiceData={modalData}
      />
      {/* <FileModal
        url={modalData?.url}
        fileType={"pdf"}
        modalData={{
          showFooter: false,
          show: modalData.open,
          onClose: () => setModalData({ open: false }),
          headerStyles: { padding: "10px" }
        }}
        bodyStyles={{
          borderRadius: "0px 0px 10px 10px",
        }}
      /> */}
    </Box>
  )
}

export default Invoice
